import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { ButtonVariant } from "Constant/button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

import useHostFooterAction from "components/organisms/CreationModal/hooks/useHostFooterAction";

import MouseOverPopover from "../../components/MouseOverPopover";
import "../../css/createSourceModal.css";
import { sendOdooData, withHttpsScheme } from "../../helpers/Sources/odoo/odoo";
import StandartButton from "../atoms/StandartButton";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import SwalAlertComp from "../SwalAlert";

const OdooSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [odooInput, setOdooSaleInput] = useState({
        name: "",
        odoo_base_url: "",
        odoo_database: "",
        odoo_username: "",
        odoo_token: "",
    });
    const [odooSourceID, setOdooSourceID] = useState("");
    const [btnCheck, setBtnCheck] = useState(true);
    const [odooData, setOdooData] = useState(null);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        name: "",
        odoo_base_url: "",
        odoo_database: "",
        odoo_username: "",
        odoo_token: "",
    });

    const language = useSelector((state) => state.languagesState.languages);

    const setLoadingState = (loading) => {
        setIsSaveLoading(loading);
        props?.setLoading?.(loading);
    };

    const handleCloseModal = () => {
        props?.handleClose?.();
        setBtnCheck(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOdooSaleInput({ ...odooInput, [name]: value });
        setErrorMessages({
            ...errorMessages,
            [name]: value ? "" : "Cannot be blank!",
        });
    };

    const fetchOdooData = async () => {
        const blankMessage =
            language?.tracker_wizard?.cannot_be_blank ?? "Cannot be blank!";
        const odooBaseUrl = withHttpsScheme(odooInput.odoo_base_url);
        const nextInput = { ...odooInput, odoo_base_url: odooBaseUrl };

        if (odooBaseUrl !== odooInput.odoo_base_url) {
            setOdooSaleInput(nextInput);
        }

        if (
            !nextInput.name ||
            !nextInput.odoo_base_url ||
            !nextInput.odoo_database ||
            !nextInput.odoo_username ||
            !nextInput.odoo_token
        ) {
            setErrorMessages({
                name: nextInput.name === "" ? blankMessage : "",
                odoo_base_url:
                    nextInput.odoo_base_url === "" ? blankMessage : "",
                odoo_database:
                    nextInput.odoo_database === "" ? blankMessage : "",
                odoo_username:
                    nextInput.odoo_username === "" ? blankMessage : "",
                odoo_token: nextInput.odoo_token === "" ? blankMessage : "",
            });
        } else {
            setLoadingState(true);
            let data = {
                name: nextInput.name,
                odoo_base_url: odooBaseUrl,
                odoo_database: nextInput.odoo_database,
                odoo_username: nextInput.odoo_username,
                odoo_token: nextInput.odoo_token,
                usage_types: [4],
            };
            let response = await sendOdooData(data);
            if (response.status) {
                setOdooData(response?.data?.field_data?.fields);
                props?.setOdooStep && props?.setOdooStep(1);
                if (props.selectFileSourceId) {
                    props.selectFileSourceId(
                        response?.data?.source?.id,
                        response?.data?.source?.source_type_id,
                    );
                }
                setBtnCheck(false);
                setOdooSourceID(response?.data?.source?.id);
                setLoadingState(false);
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
                setLoadingState(false);
            }
        }
    };

    const saveCrmMapping = (response) => {
        props?.setIsMappingSuccessfull?.(true);
        setLoadingState(true);
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            props?.handleClose(odooSourceID);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getTracker) {
                props.addToTracker(odooSourceID);
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            setOdooSourceID("");
            setBtnCheck(false);
            setLoadingState(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            setLoadingState(false);
        }
    };

    const popoverOdoo = (
        <div>
            <strong className="d-block">How to Get Token?</strong>
            Token is a unique security token generated automatically when a user
            is created in Odoo CRM. It is used for authentication in REST
            APIs/Web Services. You can find your token under Settings.
        </div>
    );

    useHostFooterAction(registerFooterAction, "form", {
        label: language?.buttons?.continue ?? "Continue",
        onSubmit: fetchOdooData,
        isLoading: isSaveLoading,
        hidden: !!odooData,
    });

    const saveButton = (
        <StandartButton
            variant="contained"
            color="primary"
            onClick={fetchOdooData}
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
            wrapperSx={{ marginLeft: "auto", width: "fit-content" }}
        >
            {language?.buttons?.create_source ?? "Create Source"}
        </StandartButton>
    );

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {odooData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={odooSourceID}
                            sourceType={"odoo"}
                            mappingSuccess={saveCrmMapping}
                            isModal={props?.isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        ></CrmSourceMappingArea>
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.name === null}
                        >
                            <TextField
                                name="name"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.please_write_name ??
                                    "Please Write Name"
                                }
                                value={odooInput?.name}
                                required
                                error={errorMessages.name === null}
                            />
                            {errorMessages?.name && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.name}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.odoo_base_url === null}
                        >
                            <TextField
                                name="odoo_base_url"
                                label={
                                    language?.source_modal?.base_url ??
                                    "Base URL"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.please_write_url ??
                                    "Please Write URL"
                                }
                                value={odooInput?.odoo_base_url}
                                required
                                error={errorMessages.odoo_base_url === null}
                            />
                            {errorMessages?.odoo_base_url && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.odoo_base_url}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.odoo_database === null}
                        >
                            <TextField
                                name="odoo_database"
                                label={
                                    language?.source_modal?.database ??
                                    "Database"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_database ??
                                    "Please Write Database"
                                }
                                value={odooInput?.odoo_database}
                                required
                                error={errorMessages.odoo_database === null}
                            />
                            {errorMessages?.odoo_database && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.odoo_database}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.odoo_username === null}
                        >
                            <TextField
                                name="odoo_username"
                                label={
                                    language?.source_modal?.username ??
                                    "Username"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_username ??
                                    "Please Write Username"
                                }
                                value={odooInput?.odoo_username}
                                required
                                error={errorMessages.odoo_username === null}
                            />
                            {errorMessages?.odoo_username && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.odoo_username}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3 mouse-over-popover-area"
                            style={{ width: "100%" }}
                            error={errorMessages.odoo_token === null}
                        >
                            <TextField
                                name="odoo_token"
                                label={language?.source_modal?.token ?? "Token"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_token ??
                                    "Please Write Token"
                                }
                                value={odooInput?.odoo_token}
                                required
                                error={errorMessages.odoo_token === null}
                            />
                            {errorMessages?.odoo_token && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.odoo_token}
                                </div>
                            )}
                            <MouseOverPopover
                                text={popoverOdoo}
                            ></MouseOverPopover>
                        </FormControl>
                    </>
                )}
            </Form.Group>

            {!useHostFooter &&
                btnCheck &&
                (props?.isModal ? (
                    <Modal.Footer className="source-modal-footer">
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={handleCloseModal}
                            disabled={isSaveLoading}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </StandartButton>
                        {saveButton}
                    </Modal.Footer>
                ) : (
                    saveButton
                ))}
        </div>
    );
};

export default OdooSource;
